<div class="text-center body-bg container-fluid">
<img class="img-fluid text-center" src="{{imgSrc}}error-404.svg" alt="image not found" width="auto" height="auto">
<div class="page-not-found">The page you’re looking for can’t be found.</div>
<div class="error-message">Sorry we couldn't find what you were looking for or the page/URL you have entered doesn't exist.</div>
<div class="error-message">If you believe that there might be an issue with the page you are tying to reach and need assistance, please email <a href="mailto:support@creditsu.co.uk" style="text-decoration: none;"> <span>support@creditsu.co.uk</span></a>.</div>
</div>

